import Names from './names'

export const SignSystem = {
  none: {
    index: 0,
    name: 'none',
    label: 'Hide'
  },
  agrippa: {
    index: 1,
    name: 'agrippa',
    label: 'Planetary'
  },
  gerard: {
    index: 2,
    name: 'gerard',
    label: 'Traditional'
  }
}

export const SignSystems = [
  {
    index: SignSystem.none.index,
    name: SignSystem.none.name,
    label: SignSystem.none.label
  },
  {
    index: SignSystem.agrippa.index,
    name: SignSystem.agrippa.name,
    label: SignSystem.agrippa.label
  },
  {
    index: SignSystem.gerard.index,
    name: SignSystem.gerard.name,
    label: SignSystem.gerard.label
  }
]

export const Signs = [
  { index:  0, name: 'aries' },
  { index:  1, name: 'taurus' },
  { index:  2, name: 'gemini' },
  { index:  3, name: 'cancer' },
  { index:  4, name: 'leo' },
  { index:  5, name: 'virgo' },
  { index:  6, name: 'libra' },
  { index:  7, name: 'scorpio' },
  { index:  8, name: 'sagittarius' },
  { index:  9, name: 'capricorn' },
  { index: 10, name: 'aquarius' },
  { index: 11, name: 'pisces' }
]

const agrippa = {
  'Puer':           0,  // Aries
  'Amissio':        1,  // Taurus
  'Albus':          2,  // Gemini
  'Populus':        3,  // Cancer
  'Fortuna Major':  4,  // Leo
  'Conjunctio':     5,  // Virgo
  'Puella':         6,  // Libra
  'Rubeus':         7,  // Scorpio
  'Acquisitio':     8,  // Sagittarius
  'Carcer':         9,  // Capricorn
  'Tristitia':      10, // Aquarius
  'Laetitia':       11, // Pisces
  'Cauda Draconis': 7,  // Scorpio
  'Caput Draconis': 9,  // Capricorn
  'Fortuna Minor':  4,  // Leo
  'Via':            3,  // Cancer
}

const gerard = {
  'Puer':           2,  // Gemini
  'Amissio':        7,  // Scorpio
  'Albus':          3,  // Cancer
  'Populus':        9,  // Capricorn
  'Fortuna Major':  10, // Aquarius
  'Conjunctio':     5,  // Virgo
  'Puella':         6,  // Libra
  'Rubeus':         2,  // Gemini
  'Acquisitio':     0,  // Aries
  'Carcer':         11, // Pisces
  'Tristitia':      7,  // Scorpio
  'Laetitia':       1,  // Taurus
  'Cauda Draconis': 8,  // Sagittarius
  'Caput Draconis': 5,  // Virgo
  'Fortuna Minor':  1,  // Taurus
  'Via':            4,  // Leo
}

export const GetSignForFigure = (fig, system) => {
  if (system === SignSystem.gerard.name) {
    return Signs[gerard[Names.getNameForFigure(fig)]]
  }

  return Signs[agrippa[Names.getNameForFigure(fig)]]
}
